<app-widget-container
  [title]="'Ad Type by Spend'"
  [control]="platformControl"
  [selectMode]="SelectMode.SINGLE"
  [selectOptions]="platformOptions"
  [searchable]="false"
  [selectWidth]="'160px'"
  [placeholder]="'All Platforms'"
  (apply)="onPlatformChange()">
  <app-content-category-distribution
    [data]="contentCategoryData"
    [myBrand]="myBrand"
    [myCompetitors]="myCompetitors"
    [brandColorsMap]="brandColorsMap"
    [loading]="loading"
    [showFullListButton]="false"
    [isAdType]="true">
  </app-content-category-distribution>
</app-widget-container>
